import { render } from "./CustomMultiSelectV2.vue?vue&type=template&id=bb2daee6"
import script from "./CustomMultiSelectV2.vue?vue&type=script&lang=js"
export * from "./CustomMultiSelectV2.vue?vue&type=script&lang=js"

import "./CustomMultiSelectV2.vue?vue&type=style&index=0&id=bb2daee6&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\60\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__